import React from "react";
import { useAppSelector } from "../../../hooks/hooks";
import {
  selectAuthStatus,
  selectMagicLinkEmail,
} from "../../../features/authentication/authenticationSlice";
import { selectBrandInfo } from "../../../features/brand/brandSlice";

import "./loginLinkConfirmation.css";

import {
  Container,
  Padding,
  Layout,
  Text,
  Sheet,
  Button,
  AnchorLink,
  Form,
  Header,
} from "@kidslivesafe/sc-react";
import { useNavigate } from "react-router-dom";

import Logo from "@assets/images/brand-logo.svg";
import HeaderLogo from "@assets/images/brand-logo--header.svg";

import { useCurrentBreakpoint } from "@kidslivesafe/sc-foundation";

const LoginLinkConfirmation: React.FC = () => {
  /* -- local state -- */

  /* -- redux state -- */
  const authStatus = useAppSelector(selectAuthStatus);
  const brandInfo = useAppSelector(selectBrandInfo);
  const email = useAppSelector(selectMagicLinkEmail);

  /* -- setup hooks -- */
  const navigate = useNavigate();

  const currentBreakPoint = useCurrentBreakpoint();

  /* -- handle submit -- */
  const handleSendAnotherLink = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
  ) => {
    if (e) {
      e.preventDefault();
    }
    navigate("/login-link-request");
  };

  const renderLogo = () => {
    switch (brandInfo.acronym) {
      case "sf":
        return (
          <img
            width={currentBreakPoint === "desktop" ? "147" : "88"}
            src={Logo}
            alt="Logo"
          />
        );
      case "pdc":
        return (
          <img
            width={currentBreakPoint === "desktop" ? "170" : "170"}
            src={Logo}
            alt="Logo"
          />
        );
      case "pis":
        return (
          <img
            width={currentBreakPoint === "desktop" ? "170" : "170"}
            src={HeaderLogo}
            alt="Logo"
          />
        );
      case "spr":
        return (
          <img
            width={currentBreakPoint === "desktop" ? "170" : "170"}
            src={HeaderLogo}
            alt="Logo"
          />
        );
      case "prr":
        return <img width="147" src={HeaderLogo} alt="Logo" />;
      case "kls":
        return (
          <img
            width={currentBreakPoint === "desktop" ? "170" : "170"}
            src={Logo}
            alt="Logo"
          />
        );
      case "qpr":
        return (
          <img
            width={currentBreakPoint === "desktop" ? "170" : "170"}
            src={Logo}
            alt="Logo"
          />
        );
      case "pf":
        return (
          <img
            width={currentBreakPoint === "desktop" ? "170" : "170"}
            src={HeaderLogo}
            alt="Logo"
          />
        );
      default:
        return (
          <img
            width={currentBreakPoint === "desktop" ? "147" : "88"}
            src={Logo}
            alt="Logo"
          />
        );
    }
  };

  return (
    <>
      {brandInfo.acronym === "qpr" ? (
        <Header
          homeUrl="/"
          displayButtons={false}
          menuButtonLinks={[]}
          logoUrl={HeaderLogo}
        ></Header>
      ) : (
        <Sheet>
          <Layout
            type="flex"
            flexProps={{ direction: "column", alignItems: "flex-start" }}
          >
            <Padding space="md">
              <div className="page-login-link-confirmation-brand-logo-container">
                <Text color="white">{renderLogo()}</Text>
              </div>
            </Padding>
          </Layout>
        </Sheet>
      )}
      <Sheet>
        <Padding space="md">
          <div
            className={
              currentBreakPoint === "desktop"
                ? "page-login-link-confirmation-sheet-form-container"
                : ""
            }
          >
            <Layout type="flex" flexProps={{ direction: "column", gap: "lg" }}>
              <Container
                bodyBorderRadius
                border={brandInfo.acronym === "qpr" ? true : false}
                customClassName="page-login-link-confirmation-container"
                altColor="login"
              >
                <Padding
                  space={["pf"].includes(brandInfo.acronym) ? "xl" : "md"}
                >
                  <Form>
                    <Layout
                      type="flex"
                      flexProps={{
                        direction: "column",
                        gap: "md",
                      }}
                    >
                      <Layout
                        type="flex"
                        flexProps={{
                          direction: "column",
                          gap: "lg",
                        }}
                      >
                        <Layout
                          type="flex"
                          flexProps={{
                            direction: "column",
                            gap: "xs",
                          }}
                        >
                          <Text tag="h1" unresponsive>
                            Almost there!
                          </Text>
                          <Text size="sm">We just sent a login to {email}</Text>
                          <Text size="sm">
                            Simply click the link in your email and you'll be
                            signed in automatically.
                          </Text>
                        </Layout>
                        <Layout
                          type="flex"
                          flexProps={{
                            direction: "column",
                            gap: "md",
                          }}
                        >
                          <Button
                            buttonText="Send me another link"
                            color="primary"
                            handleClick={handleSendAnotherLink}
                            disabled={authStatus === "loading"}
                            size="md"
                            fill="fill"
                            passThroughClassess="page-login-link-confirmation__button-border"
                          />
                        </Layout>
                      </Layout>
                      <Layout
                        type="flex"
                        flexProps={{
                          alignItems: "center",
                          direction: "column",
                          gap: "lg",
                        }}
                      >
                        <AnchorLink href="/login" target="_self" size="xs">
                          Back to regular login
                        </AnchorLink>
                        <Layout
                          type="flex"
                          flexProps={{
                            alignItems: "center",
                            direction: "column",
                            gap: "xxs",
                          }}
                        >
                          <Text size="xs">
                            Your login link will be good for 15 minutes
                          </Text>
                        </Layout>
                      </Layout>
                    </Layout>
                  </Form>
                </Padding>
              </Container>
            </Layout>
          </div>
        </Padding>
      </Sheet>
    </>
  );
};

export default LoginLinkConfirmation;
